let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("atmg2")).then(() => parcelRequire('iTSW4'));